import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import { CssBaseline, CircularProgress, Container, Button, Grid, Typography, Card, CardContent, Accordion, AccordionSummary, AccordionDetails } from "@mui/material"
import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import MyMaterialTable from '../../components/table'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import ScheduleReportButton from "../../components/report-schedule";
import * as OrganizationCategoryService from '../../services/organizationcategory.service'
import * as calledsActions from '../../redux/actions/calleds'
import { AbilityContext } from '../../config/ability-context'
import Footer from '../../components/footer'
import moment from "moment"
import { FormattedMessage, injectIntl } from 'react-intl'
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import SimpleCheckBox from "../../components/checkbox/check"
import Pagination from '@mui/material/Pagination'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

class OrganizationFieldReport extends Component {
  constructor(props) {
    super(props)

    const { userSession } = this.props
    if (userSession == null || userSession.user == null)
      Api.logoff()

    this.state = {
      OrganizationFilter: [],
      CategoryFilter: [],
      FieldTypeFilter: [],
      ActiveFilter: { id: '', name: this.props.intl.formatMessage({ id: 'all'}) },
      IsRequiredFilter: false,

      OrgsList: [],
      CategoriesList: [],
      FieldTypesList: [
        { id: 1, name: 'Texto' },
        { id: 2, name: 'Rádio' },
        { id: 3, name: 'Checkbox' },
        { id: 4, name: 'Seleção' },
        { id: 5, name: 'Número' },
        { id: 6, name: 'Seleção Múltipla' },
        { id: 7, name: 'Texto Multilinha' },
        { id: 8, name: 'Número Decimal' },
        { id: 9, name: 'Data' },
        { id: 10, name: 'Texto Regex' },
        { id: 11, name: 'Likert' },
      ],
      ActiveOptions: [
        { id: '', name: this.props.intl.formatMessage({ id: 'all' }) },
        { id: 'true', name: this.props.intl.formatMessage({ id: 'active' }) },
        { id: 'false', name: this.props.intl.formatMessage({ id: 'inactive' }) },
      ],

      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",

      showGrid: false,
      organizationFieldList: [],

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,

      columns: [],
      SelectAllOrganizations: false,
      SelectAllCategories: false,
    }
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.getOrganizations()
    this.setState({ loading: false })
  }

  getOrganizations = async () => {
    try {
      const result = await Api.get('/organizations/tech')

      let data = []
      if (result.data && result.data.data) {
        data = result.data.data
      } else if (result.data && Array.isArray(result.data)) {
        data = result.data
      }

      const dataNormalizada = data.map(item => item.organization || item)

      this.setState({ OrgsList: dataNormalizada })
    } catch (err) {
      console.error("Erro ao buscar organizações:", err)
      this.setState({ OrgsList: [] })
    }
  }

  getCategoriesByOrganizations = async (organizationList) => {
    if (!organizationList || organizationList.length === 0) {
      this.setState({ CategoriesList: [], CategoryFilter: [] })
      return
    }

    this.setState({ loading: true })

    try {
      const results = await Promise.all(
        organizationList.map(org => OrganizationCategoryService.getbyorganization(org.id))
      )

      const mergedCategories = []
      const seenIds = new Set()

      results.forEach(result => {
        if (result.success) {
          (result.data || []).forEach(category => {
            if (!seenIds.has(category.id)) {
              seenIds.add(category.id)
              mergedCategories.push(category)
            }
          })
        }
      })

      const currentCategoryFilter = this.state.CategoryFilter.filter(c => seenIds.has(c.id))

      this.setState({ CategoriesList: mergedCategories, CategoryFilter: currentCategoryFilter, loading: false })
    } catch (err) {
      console.error("Erro ao buscar categorias:", err)
      this.setState({ CategoriesList: [], loading: false })
    }
  }

  changeValues = async (stateName, value) => {
  this.setState({ loading: true })

  if (stateName === 'SelectAllOrganizations') {
    if (value === true) {
      this.setState({ SelectAllOrganizations: true, OrganizationFilter: this.state.OrgsList, page: 1 })
      await this.getCategoriesByOrganizations(this.state.OrgsList)
    } else {
      this.setState({ SelectAllOrganizations: false, OrganizationFilter: [], CategoryFilter: [], CategoriesList: [], SelectAllCategories: false, page: 1 })
    }
    this.setState({ loading: false })
    return
  }

  if (stateName === 'SelectAllCategories') {
    if (value === true) {
      this.setState({ SelectAllCategories: true, CategoryFilter: this.state.CategoriesList, page: 1 })
    } else {
      this.setState({ SelectAllCategories: false, CategoryFilter: [], page: 1 })
    }
    this.setState({ loading: false })
    return
  }

  this.setState({ [stateName]: value, page: 1 })

  if (stateName === 'OrganizationFilter') {
    this.setState({ SelectAllOrganizations: false, SelectAllCategories: false })
    await this.getCategoriesByOrganizations(value)
  }

  if (stateName === 'CategoryFilter') {
    this.setState({ SelectAllCategories: false })
  }

  this.setState({ loading: false })
};

  onChangePaginate = (e, page) => {
    this.setState({ page: page })
    this.getReportData(page)
  }

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page === 1) {
        this.setState({ pageStart: 1, pageEnd: count < 10 ? count : 10 })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        this.setState({ pageStart: pageStart, pageEnd: count >= page * 10 ? page * 10 : count })
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0 })
    }
  }

  translateFieldType = (fieldTypeId) => {
    const found = this.state.FieldTypesList.find(f => f.id === Number(fieldTypeId))
    return found ? found.name : fieldTypeId
  }

  translateBoolean = (value) => {
    return value === true || value === 'true' ? 'Sim' : 'Não'
  }

  getColumns() {
    const intl = this.props.intl
    const columns = [
      { title: 'ID', field: 'id' },
      { title: intl.formatMessage({ id: 'organization' }), field: 'organizationname' },
      { title: intl.formatMessage({ id: 'menu.categories'}), field: 'categorynames' },
      { title: intl.formatMessage({ id: 'organization.field.name',  }), field: 'fieldname' },
      {
        title: intl.formatMessage({ id: 'organization.field.type' }),
        field: 'fieldtypeid',
        render: rowData => this.translateFieldType(rowData.fieldtypeid)
      },
      {
        title: intl.formatMessage({ id: 'active'}),
        field: 'active',
        render: rowData => this.translateBoolean(rowData.active)
      },
      {
        title: intl.formatMessage({ id: 'required' }),
        field: 'isrequired',
        render: rowData => this.translateBoolean(rowData.isrequired)
      },
    ]
    this.setState({ columns: columns })
  }

  getReportData = async (page = 1) => {
    const intl = this.props.intl

    this.setState({ loading: true, organizationFieldList: [], showGrid: false })

    let organizationIds = this.state.OrganizationFilter.length > 0 ? this.state.OrganizationFilter.map(o => o.id).join(",") : ""
    let categoryIds = this.state.CategoryFilter.length > 0 ? this.state.CategoryFilter.map(c => c.id).join(",") : ""
    let fieldTypeIds = this.state.FieldTypeFilter.length > 0 ? this.state.FieldTypeFilter.map(f => f.id).join(",") : ""
    let active = this.state.ActiveFilter && this.state.ActiveFilter.id !== '' ? this.state.ActiveFilter.id : ""
    let isRequired = this.state.IsRequiredFilter ? "true" : "false"

    let url = `/report/organizationfield/paginate?page=${page}`
    url += `&organizationIds=${organizationIds}`
    url += `&categoryIds=${categoryIds}`
    url += `&fieldTypeIds=${fieldTypeIds}`
    url += `&active=${active}`
    url += `&isRequired=${isRequired}`

    // Agendamento de relatórios: captura o filtro exatamente como foi enviado.
    this.setState({ scheduleRequest: url })
    ApiReports.get(url)
      .then(result => {
        if (result.data.success) {
          let count = result.data.count || (result.data.data ? result.data.data.length : 0)
          this.setState({ count: count, showGrid: true })
          this.setPagination(count, page)

          const formattedList = result.data.data || []
          this.setState({ organizationFieldList: formattedList, loading: false })
          this.getColumns()
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data?.errors?.[0] || intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        this.setState({
          loading: false, openNotification: true, notificationVariant: 'error',
          notificationMessage: err.response?.data?.errors?.[0] || intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })
  }

  exportPlan = async () => {
    this.setState({ loading: true })

    let organizationIds = this.state.OrganizationFilter.length > 0 ? this.state.OrganizationFilter.map(o => o.id).join(",") : ""
    let categoryIds = this.state.CategoryFilter.length > 0 ? this.state.CategoryFilter.map(c => c.id).join(",") : ""
    let fieldTypeIds = this.state.FieldTypeFilter.length > 0 ? this.state.FieldTypeFilter.map(f => f.id).join(",") : ""
    let active = this.state.ActiveFilter && this.state.ActiveFilter.id !== '' ? this.state.ActiveFilter.id : ""
    let isRequired = this.state.IsRequiredFilter ? true : false

    let data = {
      OrganizationIds: organizationIds,
      CategoryIds: categoryIds,
      FieldTypeIds: fieldTypeIds,
      Active: active,
      IsRequired: isRequired
    }

    ApiReports.post(`/report/organizationfield/excel`, data)
      .then((response) => {
        if (response.data.success) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")"
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: response.data.errors?.[0] || this.props.intl.formatMessage({ id: "process.error" })
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: error.response?.data?.errors?.[0] || this.props.intl.formatMessage({ id: "process.error" })
        });
      });
  }

  handleClearFilters = () => {
  this.setState({
    OrganizationFilter: [],
    CategoryFilter: [],
    FieldTypeFilter: [],
    ActiveFilter: { id: '', name: this.props.intl.formatMessage({ id: 'all' }) },
    IsRequiredFilter: false,
    SelectAllOrganizations: false,
    SelectAllCategories: false,
    CategoriesList: [],
    page: 1,
    showGrid: false,
    organizationFieldList: []
  });
}

  handleSubmit = e => {
    e.preventDefault();
    this.getReportData(1);
  }

  closeNotification = () => {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu, intl } = this.props

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    const tableList = () => {
      return (
        <>
          <form className={classes.form} onSubmit={this.handleSubmit}>
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <SimpleAutoCompleteMultiple
                      label={intl.formatMessage({ id: "organization" })}
                      options={this.state.OrgsList}
                      stateName='OrganizationFilter'
                      selected={this.state.OrganizationFilter}
                      changeSelect={this.changeValues}
                    />
                     <SimpleCheckBox
                        key={`select-all-orgs-${this.state.SelectAllOrganizations}`}
                        label={intl.formatMessage({ id: "select.all.organizations" })}
                        name='SelectAllOrganizations'
                        stateName='SelectAllOrganizations'
                        changeSelect={this.changeValues}
                        selected={this.state.SelectAllOrganizations}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <SimpleAutoCompleteMultiple
                      label={intl.formatMessage({ id: "menu.categories" })}
                      options={this.state.CategoriesList}
                      stateName='CategoryFilter'
                      selected={this.state.CategoryFilter}
                      changeSelect={this.changeValues}
                    />
                    <SimpleCheckBox
                    key={`cat-${this.state.SelectAllCategories}`} 
                    label={intl.formatMessage({ id: "select.all.categories" })}
                    name='SelectAllCategories'
                    stateName='SelectAllCategories'
                    changeSelect={this.changeValues}
                    selected={this.state.SelectAllCategories}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <SimpleAutoCompleteMultiple
                      label={intl.formatMessage({ id: "organization.field.type",  })}
                      options={this.state.FieldTypesList}
                      stateName='FieldTypeFilter'
                      selected={this.state.FieldTypeFilter}
                      changeSelect={this.changeValues}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "active" })}
                      options={this.state.ActiveOptions}
                      stateName='ActiveFilter'
                      selected={this.state.ActiveFilter}
                      changeSelect={this.changeValues}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} style={{ display: 'flex', alignItems: 'center' }}>
                    <SimpleCheckBox
                      label={intl.formatMessage({ id: "required", })}
                      name='IsRequiredFilter'
                      stateName='IsRequiredFilter'
                      changeSelect={this.changeValues}
                      selected={this.state.IsRequiredFilter}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Grid container style={{ marginBottom: 10, marginTop: 10 }} spacing={2}>
              <Grid item xs={12} sm={4} md={2}>
                <Button type='submit' fullWidth variant='contained' color='secondary'>
                  <FormattedMessage id="filter" />
                </Button>
              </Grid>

              <Grid item xs={12} sm={4} md={2}>
                <Button type='button' fullWidth variant='contained' color='secondary' onClick={this.handleClearFilters}>
                  <FormattedMessage id="clear" />
                </Button>
              </Grid>

              {this.state.showGrid && (
                <Grid item xs={12} sm={4} md={3}>
                  <Button fullWidth variant='contained' color='primary' onClick={this.exportPlan} disabled={this.state.count === 0}>
                    <FormattedMessage id="export.plan" />
                  </Button>
                </Grid>
              )}
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={4} md={3}>
  <ScheduleReportButton reportKey="organization-field" request={this.state.scheduleRequest} color="primary" />
</Grid>}
            </Grid>
          </form>

          {this.state.showGrid && (
            <>
              <MyMaterialTable
                title=""
                columns={this.state.columns}
                data={this.state.organizationFieldList}
              />
              <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                  <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={6} style={{ marginTop: 6 }}>
                  {this.state.pageStart} <FormattedMessage id="to" /> {this.state.pageEnd} <FormattedMessage id="of" /> {this.state.count} <FormattedMessage id="register" />
                </Grid>
              </Grid>
            </>
          )}
        </>
      );
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })} >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      {intl.formatMessage({ id: "organization.field.report" })}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {tableList()}

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

OrganizationFieldReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch => bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(OrganizationFieldReport)))
OrganizationFieldReport.contextType = AbilityContext